module.exports = __webpack_public_path__ + "img/p_selectedC@2x.0f3c134d.png";